import { getSiteKey } from "../firebaseConfig";

export enum MessageType {
    SMS = "SMS",
    WhatsApp = "WhatsApp",
    Email = "Email"
}

export enum WhatsAppTemplates {
    VerifyPin = "HX7e6714992ca63ecebcff26b37bee7865",
    NotifyOrderStatusChange = "HX8dd66ecf90b199c85ac4eebf436282ee",
    ConfirmNewOrder = "confirm_new_order"
}

export interface SendMessageRequest {
    messageType: MessageType;
    toAddress: string;
    message: string;
    subject: string;
    whatsappTemplate?: WhatsAppTemplates;
    whatsappTemplateParams?: {[key: string]: string}
}

export interface SendPinRequest {
    messageType: MessageType;
    toAddress: string;
}

export interface VerifyPinRequest {
    toAddress: string;
    pin: string;
}

export const MessageGateway = {
    SendMessage: async (
        data: SendMessageRequest,
        idToken: string
    ): Promise<Response> => {

        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/send`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${idToken}`,
                "x-client-key": getSiteKey()
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error sending the message. (Status code: ${response.status})`, errorData)
            throw new Error(errorData.message || "Failed to send message");
        }

        return response;
    },
    SendPin: async (
        data: SendPinRequest
    ): Promise<Response> => {

        const params = new URLSearchParams({
            toAddress: data.toAddress,
            messageType: data.messageType
        });

        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/sendPin?${params.toString()}`, {
            method: "GET",
            headers: {
                "x-client-key": getSiteKey()
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error sending the pin. (Status code: ${response.status})`, errorData)
            throw new Error(errorData.message || "Failed to send pin");
        }

        return response;
    },
        VerifyPin: async (
        data: VerifyPinRequest
    ): Promise<Response> => {

        const params = new URLSearchParams({
            toAddress: data.toAddress,
            pin: data.pin
        });

        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/verifyPin?${params.toString()}`, {
            method: "GET",
            headers: {
                "x-client-key": getSiteKey()
            }
        });

        return response;
    },
}